module.exports = __webpack_public_path__ + "static/media/youtube-rounded-icon.1362ae72.png";